import EPermissionTypes from 'enums/permissionTypes';
import EUserType from 'enums/userTypes';

interface INavItem {
  access: string[];
  children?: Array<INavItem>;
  href: string;
  label: string;
  permission?: string;
}
export const NAV_ITEMS: Array<INavItem> = [
  {
    label: 'menu.welcome',
    href: '/home',
    access: [
      EUserType.Owner,
      EUserType.Admin,
      EUserType.Accountant,
      EUserType.Technician,
    ],
  },
  {
    label: 'menu.account',
    href: '/account',
    access: [
      EUserType.Owner,
      EUserType.Admin,
      EUserType.Accountant,
      EUserType.Technician,
    ],
  },
  {
    label: 'menu.company_management',
    href: '/company/edit',
    access: [EUserType.Owner, EUserType.Admin],
    permission: EPermissionTypes.CompanyDetails,
  },
  {
    label: 'menu.user_management',
    href: '/worker',
    access: [EUserType.Owner, EUserType.Admin],
    permission: EPermissionTypes.UserManagement,
  },
  {
    label: 'menu.help',
    href: '/help',
    access: [
      EUserType.Owner,
      EUserType.Admin,
      EUserType.Accountant,
      EUserType.Technician,
    ],
  },
];
